import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cookie-info-modal",
    role: "dialog",
    "aria-labelledby": "cookie-info-title",
    "aria-modal": "true"
};
const _hoisted_2 = { class: "cookie-info-content" };
const _hoisted_3 = { class: "cookie-info-header" };
const _hoisted_4 = { class: "cookie-info-header-left" };
const _hoisted_5 = {
    id: "cookie-info-title",
    class: "cookie-info-title"
};
const _hoisted_6 = { class: "cookie-info-body" };
const _hoisted_7 = { class: "cookie-info-text" };
const _hoisted_8 = { class: "intro-text" };
const _hoisted_9 = { class: "info-subtitle" };
const _hoisted_10 = { class: "cookie-types" };
const _hoisted_11 = { class: "cookie-type" };
const _hoisted_12 = { class: "cookie-type-header" };
const _hoisted_13 = { class: "cookie-type-name" };
const _hoisted_14 = { class: "cookie-type-description" };
const _hoisted_15 = { class: "cookie-type" };
const _hoisted_16 = { class: "cookie-type-header" };
const _hoisted_17 = { class: "cookie-type-name" };
const _hoisted_18 = { class: "cookie-type-description" };
const _hoisted_19 = { class: "info-note" };
const _hoisted_20 = { class: "note-text" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'CookieInfoModal',
    props: {
        visible: { type: Boolean },
        t: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const onClose = () => {
            emit('close');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
                default: _withCtx(() => [
                    (__props.visible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                                class: "cookie-info-overlay",
                                onClick: onClose
                            }),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.t?.cookieInfo?.title || 'About Cookies'), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "cookie-info-close",
                                        onClick: onClose,
                                        "aria-label": "Close cookie information"
                                    }, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none"
                                            }, [
                                                _createElementVNode("path", {
                                                    d: "M18 6L6 18M6 6L18 18",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                })
                                            ], -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("p", _hoisted_8, _toDisplayString(__props.t?.cookieInfo?.intro || 'Cookies are small text files that are stored on your device when you visit websites. We use cookies to improve site functionality and collect anonymous statistics.'), 1),
                                        _createElementVNode("h3", _hoisted_9, _toDisplayString(__props.t?.cookieInfo?.typesTitle || 'Types of cookies we use:'), 1),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(__props.t?.cookieInfo?.necessaryTitle || 'Necessary cookies'), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_14, _toDisplayString(__props.t?.cookieInfo?.necessaryDescription || 'Ensure basic website functionality (navigation, consent storage). They don\'t require your consent.'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createElementVNode("span", _hoisted_17, _toDisplayString(__props.t?.cookieInfo?.analyticsTitle || 'Analytics cookies'), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_18, _toDisplayString(__props.t?.cookieInfo?.analyticsDescription || 'Help us understand how visitors use the site, which pages are most popular. This data is anonymous and used solely for site improvement. They are activated only after your consent.'), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("p", _hoisted_20, _toDisplayString(__props.t?.cookieInfo?.note || 'We DO NOT use advertising cookies, third-party trackers, or personal data collection systems without your explicit consent.'), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
